<div class="modal-content">
  <span class="list-title">COMMENT PROMPT SETTINGS</span>
  <div class="edit-message-bloc create-section mr-md-3">
    <div class="prompt-intro mb-3">All this settings are here to help you. Fill as much as you need!</div>
    <div class="prompt-content">
      <div class="half">
        <div class="form-group">
          <label for="subject">Product/company</label>
          <input type="text" class="edit-message-bloc-input" id="product" [(ngModel)]="product" placeholder="What are you promoting in your post?" />
        </div>
        <div class="form-group">
          <label for="objective">Objective</label>
          <input type="text" class="edit-message-bloc-input" id="objective" [(ngModel)]="objective" placeholder="What's the purpose of your reply?" />
        </div>
        <div class="form-group">
          <label for="role">Role</label>
          <input type="text" class="edit-message-bloc-input" id="role" [(ngModel)]="role" placeholder="What's your role in your post?" />
        </div>
        <div class="form-group">
          <label for="websiteUrl">Your Website</label>
          <input type="text" class="edit-message-bloc-input" id="websiteUrl" [(ngModel)]="websiteURL" placeholder="Enter your website link" />
        </div>
        <div class="form-group">
          <label for="role">Reply Length (Number of Words)</label>
          <input type="number" class="edit-message-bloc-input" [(ngModel)]="wordNumber" placeholder="Number of words (Positive Number over 0)" />
        </div>
      </div>
      <div class="separator"></div>
      <div class="half">
        <div class="form-group">
          <label for="name">Language of your reply</label>
          <div>
            <app-simple-dropdown
              required
              id="language"
              [highlightSelectedItem]="true"
              [input]="language"
              [dicoValues]="dicoLanguage"
              [textSize]="'1rem'"
            ></app-simple-dropdown>
          </div>
        </div>
        <div class="form-group">
          <label for="name">Tone of your reply</label>
          <div>
            <app-simple-dropdown
              required
              id="tone"
              [highlightSelectedItem]="true"
              [input]="tone"
              [dicoValues]="dicoTone"
              [textSize]="'1rem'"
            ></app-simple-dropdown>
          </div>
        </div>
        <div class="form-group">
          <label for="name">Use Emojis in your reply</label>
          <div>
            <app-simple-dropdown
              required
              id="tone"
              [highlightSelectedItem]="true"
              [input]="useEmojis"
              [dicoValues]="dicoUseEmojis"
              [textSize]="'1rem'"
            ></app-simple-dropdown>
          </div>
        </div>
        <div class="form-group">
          <label for="name">Ask a question in your reply</label>
          <div>
            <app-simple-dropdown
              required
              id="tone"
              [highlightSelectedItem]="true"
              [input]="useQuestion"
              [dicoValues]="dicoUseQuestion"
              [textSize]="'1rem'"
            ></app-simple-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="prompt-generate-content">
    <button class="custom-btn custom-btn-primary" (click)="generatePrompt()">Generate Prompt</button>
  </div>

  <div *ngIf="promptGenerated && generatedPrompt !== ''" class="select-action-container">
    <textarea
      type="text"
      rows="10"
      class="edit-message-bloc-input prompt"
      id="prompt"
      name="prompt"
      [(ngModel)]="generatedPrompt"
      placeholder="Generated Prompt"
    ></textarea>
  </div>

  <div class="edit-campaign-action-btn-container">
    <button type="button" class="custom-btn custom-btn-warning" (click)="close()">CANCEL</button>
    <button (click)="setPrompt()" class="custom-btn custom-btn-success" [disabled]="!promptGenerated || generatedPrompt === ''">
      USE THIS PROMPT
    </button>
  </div>
</div>
